module.exports = __webpack_public_path__ + "static/media/logo-walink.ab93e7c6.svg";